//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { TableCell, TableHead, TableRow } from '@mui/material';
import React from 'react';

const headCellSx = {
  textAlign: 'left',
  fontSize: '0.8125rem',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  py: 1.25,
  px: 1.5,
  bgcolor: 'grey.50',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

const AdminSearchTable = ({ selectedFilter }) => {
  const isOrg = selectedFilter === 'district' || selectedFilter === 'school';

  return (
    <TableHead>
      <TableRow>
        <TableCell sx={headCellSx}>{isOrg ? 'Name' : 'First Name'}</TableCell>
        <TableCell sx={headCellSx}>
          {isOrg
            ? selectedFilter === 'school'
              ? 'District Name'
              : 'Schools'
            : 'Last Name'}
        </TableCell>
        <TableCell sx={headCellSx}>
          {isOrg ? (selectedFilter === 'school' ? 'Licenses' : 'Teachers') : 'Username'}
        </TableCell>
        <TableCell sx={headCellSx}>
          {isOrg ? (selectedFilter === 'school' ? 'Licenses used' : 'Students') : 'Password'}
        </TableCell>
        <TableCell sx={headCellSx}>
          {isOrg ? (selectedFilter === 'school' ? 'Licenses available' : 'Licenses') : 'District Name'}
        </TableCell>
        <TableCell sx={headCellSx}>
          {isOrg ? (selectedFilter === 'school' ? 'Teachers' : 'Licenses used') : 'School Name'}
        </TableCell>
        <TableCell sx={headCellSx}>
          {isOrg ? (selectedFilter === 'school' ? 'Students' : 'Licenses available') : 'Role'}
        </TableCell>
        <TableCell sx={headCellSx}>Integration</TableCell>
        {!isOrg ? <TableCell sx={headCellSx}>Details</TableCell> : null}
      </TableRow>
    </TableHead>
  );
};

export default AdminSearchTable;
